import { t } from '@/i18n'

import { formatCurrency } from '../fomatter.utils'
import { BODY_FONT, splitLines, wrapText } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class Total implements TicketElement {
  label: string
  fontSize: number
  value: number
  lineHeight: number
  formattedValue: string
  paddingTop: number
  diners?: number | null
  isFullBill: boolean
  secondaryLabel: string

  constructor(
    value: number,
    diners?: number | null,
    type?: 'with-tips' | 'total' | 'products' | null
  ) {
    this.label = (type === 'with-tips' ? t('bill.total-without-tips') : t('bill.total')) + ':'
    this.fontSize = type === 'with-tips' ? 22 : 26
    this.value = value
    this.lineHeight = 20
    this.formattedValue = formatCurrency(this.value)
    this.paddingTop = 32
    this.diners = diners
    this.isFullBill = type === 'total'
    this.secondaryLabel = t('bill.total-per-person')
  }

  height(ctx: CanvasRenderingContext2D, width: number) {
    ctx.font = `bold ${this.fontSize}px ${BODY_FONT}`
    const valueWidth = width - (ctx.measureText(this.label).width + 10)
    ctx.textAlign = 'right'
    let height =
      this.lineHeight * splitLines(ctx, this.formattedValue, valueWidth).length + this.paddingTop
    if (this.diners && this.diners > 1 && this.isFullBill) height += this.lineHeight
    return height
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number) {
    if (!this.value) return
    top += this.paddingTop
    ctx.font = `bold ${this.fontSize}px ${BODY_FONT}`
    ctx.fillStyle = 'black'
    ctx.textBaseline = 'bottom'
    ctx.textAlign = 'left'
    ctx.fillText(this.label, 0, top)
    let valueWidth = width - (ctx.measureText(this.label).width + 10)
    ctx.textAlign = 'right'
    wrapText(ctx, this.formattedValue, width, top, valueWidth)
    if (this.diners && this.diners > 1 && this.isFullBill) {
      this.secondaryLabel += ` (${this.diners}) :`
      top += splitLines(ctx, this.formattedValue, valueWidth).length * this.lineHeight
      ctx.font = `16px ${BODY_FONT}`
      ctx.textAlign = 'left'
      ctx.fillText(this.secondaryLabel, 0, top)
      ctx.textAlign = 'right'
      valueWidth = width - (ctx.measureText(this.secondaryLabel).width + 10)
      wrapText(ctx, formatCurrency(Math.ceil(this.value / this.diners)), width, top, valueWidth)
    }
  }
}
